export default "__VITE_ASSET__5c836b83__"